<template>
  <list-layout class="ParamsMaps">
    <template slot="filterItem">
      <search-item label="参数名称">
        <el-input
          :value="storeFilters.name"
          @input="val => updateFilters({name: val})"
          clearable
          :maxlength="20"
        />
      </search-item>
    </template>

    <template slot="filterBtn">
      <el-button
        v-if="$route.meta.btns && $route.meta.btns['0001']"
        type="primary"
        @click="searchList"
      >
        查询
      </el-button>
      <el-button
        v-if="$route.meta.btns && $route.meta.btns['0002']"
        type="primary"
        @click="showEditDialog(0)"
      >
        新增
      </el-button>
    </template>

    <Table
      :listData="listData"
      :showEditDialog="showEditDialog"
      :showDetailDialog="showDetailDialog"
      :deleteParams="deleteParams"
    />

    <template slot="footer">
      <md-pagination
        :pagination="pagination"
        :changePage="changePage"
        :changeSizeHandle="changeSizeHandle"
      />
    </template>

    <EditDialog
      :visible.sync="dialogEditVisible"
      :resetDialog="resetEditDialog"
      :type="editType"
      :selected="selected"
      :submitUpdateHandle="updateSelected"
      :cancelHandle="resetEditDialog"
      :inputTypeOptions="inputTypeOptions"
      :addValueRangeKey="addValueRangeKey"
      :delValueRangeKey="delValueRangeKey"
    />

    <DetailDialog
      :visible.sync="dialogDetailVisible"
      :resetDialog="resetDetailDialog"
      :selected="selected"
    />
  </list-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
const ListMixin = manageShell.default.mixinModule.ListPage;
import Table from './components/Table';
import EditDialog from './components/EditDialog';
import DetailDialog from './components/DetailDialog';
import {
  addParamsMap,
  updateParamsMap,
  deleteParamsMap,
} from '../../../api/equipmentParamsManagement/paramsMaps';

export default {
  name: 'ParamsMaps',
  components: {
    Table,
    EditDialog,
    DetailDialog,
  },
  mixins: [ListMixin],
  data() {
    return {
      inputTypeOptions: [
        { value: 1, label: '文本' },
        { value: 2, label: '下拉' },
      ],
    };
  },
  computed: {
    ...mapGetters('equipmentParams/ParamsMaps', {
      storeFilters: 'filters',
      listData: 'paramsMapList',
      pagination: 'pagination',
    }),
  },
  methods: {
    ...mapActions('equipmentParams/ParamsMaps', [
      'fetchParamsMapList',
      'updatePagination',
      'updateFilters',
    ]),
    initSelected() {
      return {
        id: '',
        name: '',
        inputType: undefined,
        cmdCode: '',
        cmdCodeUp: '',
        description: '',
        valuesRangeArr: [],
        valuesRange: '',
      };
    },
    fetchList(entity) {
      return this.fetchParamsMapList(entity);
    },
    showEditDialog(type, data) {
      this.editType = type;
      if (type === 0) {
        this.selected = this.initSelected();
        this.dialogEditVisible = true;
      } else if (type === 1) {
        let valuesRangeArr = [];
        if (data.valuesRange) {
          try {
            valuesRangeArr = JSON.parse(data.valuesRange);
          } catch (error) {
            console.log('JSON.parse err:', error, data.valuesRange);
          }
        }
        this.selected = {
          ...data,
          valuesRangeArr,
        };
        this.dialogEditVisible = true;
      }
    },
    validateParamsMap() {
      if (!this.selected.name) {
        this.$message.error('请输入参数名称！');
        return;
      }
      if (!this.selected.cmdCode) {
        this.$message.error('请输入下行控制类型码！');
        return;
      }
      if (!this.selected.description) {
        this.$message.error('请输入功能说明！');
        return;
      }
      if (!this.selected.inputType) {
        this.$message.error('请选择输入类型！');
        return;
      }
      if (this.selected.inputType === 2) {
        this.selected.valuesRangeArr = this.selected.valuesRangeArr.filter(
          item => item.key
        );
        this.selected.valuesRange = JSON.stringify(
          this.selected.valuesRangeArr
        );
      }
      return true;
    },
    addValueRangeKey() {
      this.selected.valuesRangeArr.push({
        key: '',
        value: '',
      });
    },
    delValueRangeKey(idx) {
      this.selected.valuesRangeArr.splice(idx, 1);
    },
    updateSelected() {
      if (this.validateParamsMap()) {
        const type = this.editType;
        if (type === 0) {
          const entity = {
            cmdCode: this.selected.cmdCode,
            cmdCodeUp: this.selected.cmdCodeUp,
            description: this.selected.description,
            name: this.selected.name,
            inputType: this.selected.inputType,
            valuesRange:
              this.selected.inputType == 1 ? '' : this.selected.valuesRange,
          };
          addParamsMap({
            data: entity,
          })
            .then(res => {
              this.fetchList();
              this.resetEditDialog();
              this.$message.success(res.msg || '添加成功！');
            })
            .catch(err => {
              this.$message.error(err.msg || '添加失败！');
            });
        } else if (type === 1) {
          const entity = {
            cmdCode: this.selected.cmdCode,
            cmdCodeUp: this.selected.cmdCodeUp,
            description: this.selected.description,
            name: this.selected.name,
            id: this.selected.id,
            inputType: this.selected.inputType,
            valuesRange:
              this.selected.inputType == 1 ? '' : this.selected.valuesRange,
          };
          updateParamsMap({
            data: entity,
          })
            .then(res => {
              this.fetchList();
              this.resetEditDialog();
              this.$message.success(res.msg || '修改成功！');
            })
            .catch(err => {
              this.$message.error(err.msg || '修改失败！');
            });
        }
      }
    },
    deleteParams(data) {
      this.$confirm(`确定删除该参数字段?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteParamsMap({
            data: {
              id: data.id,
            },
          })
            .then(res => {
              this.fetchList();
              this.$message.success(res.msg || '删除成功！');
            })
            .catch(err => {
              console.log(err);
              err.msg ? null : this.$message.error('请求失败！');
            });
        })
        .catch(action => {
          console.log(action);
        });
    },
    showDetailDialog(data) {
      this.selected = {
        cmdCode: data.cmdCode,
        cmdCodeUp: data.cmdCodeUp,
        description: data.description,
        name: data.name,
        id: data.id,
      };
      this.dialogDetailVisible = true;
    },
  },
};
</script>
